/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalRequestItem } from './PortalRequestItem';
import {
    PortalRequestItemFromJSON,
    PortalRequestItemFromJSONTyped,
    PortalRequestItemToJSON,
    PortalRequestItemToJSONTyped,
} from './PortalRequestItem';

/**
 * 
 * @export
 * @interface PortalRequestItemResponse
 */
export interface PortalRequestItemResponse {
    /**
     * 
     */
    data: PortalRequestItem;
}

/**
 * Check if a given object implements the PortalRequestItemResponse interface.
 */
export function instanceOfPortalRequestItemResponse(value: object): value is PortalRequestItemResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalRequestItemResponseFromJSON(json: any): PortalRequestItemResponse {
    return PortalRequestItemResponseFromJSONTyped(json, false);
}

export function PortalRequestItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalRequestItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalRequestItemFromJSON(json['data']),
    };
}

export function PortalRequestItemResponseToJSON(json: any): PortalRequestItemResponse {
    return PortalRequestItemResponseToJSONTyped(json, false);
}

export function PortalRequestItemResponseToJSONTyped(value?: PortalRequestItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalRequestItemToJSON(value['data']),
    };
}

